import { useCSP } from '@/components/providers/CSPProvider'

export function useCSPNonce(): string | null {
  const { nonce } = useCSP()
  return nonce
}

export function getNonceFromMeta(): string | null {
  if (typeof document === 'undefined') return null

  const meta = document.querySelector('meta[name="csp-nonce"]')
  return meta?.getAttribute('content') || null
}

